import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "transactions";
// initial state
const state = () => ({
  all: [],
  transactions: [],
  transaction: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getTransaction: (state) => {
    return state.transaction;
  },

  getTransactions: (state) => {
    return state.transactions;
  },

  getTotalAmount: (state) =>
    state.transactions.reduce((acc, val) => acc + parseFloat(val.amount), 0),
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let transactions = response.data;
      commit("SET_TRANSACTIONS", transactions);
      window.location;
    });
  },

  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let transaction = response.data;
      commit("setTransaction", transaction);
    });
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;
      if (status == "success") {
        router.push({
          name: "transactions-index",
        });
      }
    });
  },

  async update({ dispatch }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let status = response.data.status;

        if (status == "success") {
          router.push({
            name: "transactions-index",
          });
        }
      });
  },

  async destroy({ dispatch, commit }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let status = response.data.status;
      let transactions = response.data.data;
      if (status == "success") commit("SET_TRANSACTIONS", transactions);
    });
  },

  async filter({ dispatch, commit }, data) {
    await axios.post(api + "_filter", data).then((response) => {
      let transactions = response.data;
      commit("SET_TRANSACTIONS", transactions);
    });
  },

  async print({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "La liste des paiements du client est en cours de téléchargement. Veuillez patienter...",
        },
        { root: true }
      );
      const response = await axios
        .post(api + "_print", data, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Paiements.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async printReceipt({ dispatch }, reference) {
    await printData(
      { reference },
      api + "_print_receipt/" + reference,
      "POST",
      null,
      null
    );
  },
};

// mutations
const mutations = {
  SET_TRANSACTIONS(state, transactions) {
    state.all = transactions;
    state.transactions = transactions;
  },
  setTransaction(state, transaction) {
    state.transaction = transaction;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
